// This file is bundled into the public code. Do not put secrets here.

export const REACT_APP_API_URL = 'https://bioresponse-api.dpi.nsw.gov.au';
export const REACT_APP_SENTRY_DSN = 'https://ad91ac6506354bc5a246cdf15c20e3ff@o4504869159370752.ingest.sentry.io/4504873775202304';
export const REACT_APP_SENTRY_RELEASE = 'prod-2024-05-20_04:49';
export const REACT_APP_COGNITO_USER_POOL_ID = '{{ REACT_APP_COGNITO_USER_POOL_ID }}';
export const REACT_APP_COGNITO_USER_POOL_CLIENT_ID = '{{ REACT_APP_COGNITO_USER_POOL_CLIENT_ID }}';
export const REACT_APP_COGNITO_DOMAIN = '{{ REACT_APP_COGNITO_DOMAIN }}';
export const REACT_APP_DOMAIN = '';
